import format from "date-fns/format";
import pl from "date-fns/locale/pl";
import React, { useEffect, useRef, useState } from "react";
import { DayPicker } from "react-day-picker";
import { BsCalendarDate } from "react-icons/bs";
import { Ticket } from "../../../models/Ticket";
import useCalendarSale from "../../CalendarSale/hooks/useCalendarSale";
import "./style.scss";
import "./newDateModal.scss";
import ModalComponent from "../../../../features/ModalComponent";
import { useTranslation } from "react-i18next";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";


interface IProps {
  ticket: Ticket;
  handleSetPassId: (passId: number) => void;
  handleSetExerciseId: (exerciseId: number) => void;
  alertCalendar: string;
}

const NewDateChoose: React.FC<IProps> = ({ ticket, handleSetPassId, handleSetExerciseId, alertCalendar }: IProps) => {
  const locale = useLocaleByLanguage();
  const { t } = useTranslation();
  const [term, setTerm] = useState<number>(999);
  const { getDaysAvailableByPassId, listaDat, getExercisesByPassIds, exercise, selectedDate, getAssignByTicket } =
    useCalendarSale();

  useEffect(() => {
    getDaysAvailableByPassId(ticket.objectId);

  }, []);
  const selectedOrderRef = useRef<HTMLDivElement>(null);

  const scrollToSelectedOrder = () => {
    if (selectedOrderRef.current) {
      selectedOrderRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <React.Fragment>
      <div className="new-date-conatainer">
        <div className="step flex-start-center">
          <b>1</b>
          <span>{t("wybierz_date")}</span>
        </div>

        <div className="calendar">
          <DayPicker
            mode="single"
            locale={locale}
            selected={selectedDate}
            fromDate={new Date(ticket.validfrom)}
            toDate={new Date(ticket.validto)}
            onSelect={(date) => {
              getExercisesByPassIds(date ?? new Date(), ticket.objectId);
              // setOpen(!open);
              scrollToSelectedOrder();
            }}
            showOutsideDays
            modifiersClassNames={{
              selected: "my-selected",
              today: "my-today",
            }}
            disabled={listaDat}
          />
          <div className="calendar-legend flex-start-center">
            <div className="calendar-legend-dot"></div>
            <b>{t("dostepne_terminy")}</b>
          </div>
        </div>
        <div className="step flex-start-center">
          <b>2</b>
          <span>{t("wybierz_godzine")}</span>
        </div>
        <div className="hours-container" ref={selectedOrderRef}>
          {exercise[0] && <b>{exercise[0].name}</b>}

          <div className="hours flex-start-center flex-wrap">
            {exercise.map((item, index) => (
              <button
                className={`single-hour  ${index === term ? "single-hour-active" : ""
                  }`}
                onClick={() => {
                  handleSetPassId(ticket.objectId);
                  handleSetExerciseId(item.objectId);
                  setTerm(index);
                }}
                key={index}>
                <b>{format(item.startTime, "HH:mm")} - {format(item.closeTime, "HH:mm")}</b>
              </button>
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NewDateChoose;
